import { FunctionComponent, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductModalProps } from '@cdaas/reusable-components-daas';
import { Flex, Div, BodyText, Gutter, Image as TeliaImage } from '@gaiads/telia-react-component-library';
import { LocalBundleEnvelope, LocalProduct } from '@cdaas/api-clients/dist/product-service-openapi';

import { getProductFirstImage, getProductAllImages } from '../../utils';

interface AddonProductProps {
  bundle: LocalBundleEnvelope;
  addon: LocalProduct;
  index: number;
  setModalState: (value: SetStateAction<ProductModalProps>) => void;
}

export const AddonProduct: FunctionComponent<AddonProductProps> = ({ bundle, addon, index, setModalState }) => {
  const { t } = useTranslation('approval');
  const { t: translateGlobal } = useTranslation('globalComponents');

  const rightAddon = bundle.bundle.items.find(item => item.options[0].product_id === addon.id)!;
  const addonImageSrc = getProductFirstImage(bundle.variant_images ?? [], rightAddon.options[0].image_ids);
  return addonImageSrc ? (
    <>
      <Flex centeredVertically>
        <Div style={{ width: '40px' }}>
          {!!getProductFirstImage(bundle.variant_images ?? [], rightAddon.options[0].image_ids) && (
            <TeliaImage src={addonImageSrc} alt={`${translateGlobal('imageAltTexts.altAddonImage')}, ${addon.name}`} />
          )}
        </Div>
        <BodyText margin={{ left: 'xs' }}>{addon.name ?? ''}</BodyText>
      </Flex>

      <Flex centeredVertically spaceBetween>
        <BodyText margin={{ left: 'xlg' }} size={'xs'} color={'gray500'}>
          {rightAddon.options[0].sku}
        </BodyText>
        <BodyText
          size={'sm'}
          color={'purple500'}
          fontWeight="medium"
          clickableAppearance
          onClick={() => {
            setModalState(prevState => ({
              ...prevState,
              isOpen: true,
              product: addon,
              product_sku: rightAddon.options?.[0]?.sku,
              images: getProductAllImages(rightAddon.options[0].image_ids ?? [], bundle.variant_images ?? []),
            }));
          }}
        >
          {t('OrderDetails.details')}
        </BodyText>
      </Flex>
      {index !== bundle.addon_products!.length - 1 && <Gutter />}
    </>
  ) : (
    <></>
  );
};
